import { FC } from "react";
import { Styled } from "./styled";
import useImg, { IProps } from "./hook";
import { max } from "lodash";

const ImgLayout = (props: ReturnType<typeof useImg>) => {
  return (
    <Styled>
      <img
        src={props.uri}
        width={"100%"}
        style={{
          maxHeight: "calc(100% - 10px)",
          objectFit: "contain",
        }}
      />
    </Styled>
  );
};

const Img: FC<IProps> = (props: IProps) => <ImgLayout {...useImg(props)} />;

export default Img;
